import { useSelector } from 'react-redux'
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import {
  LoginView,
  DashboardView,
  DependencyTrackView,
  UpgradesView,
  ClientOrganizationView
} from './views'

const AuthBootSplash = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    <CircularProgress size={32} />
  </Box>
)

const ProtectedRoute = ({ children }) => {
  const { ready = false, isAuthenticated = false } = useSelector((state) => state.auth)
  const location = useLocation()

  if (!ready) return <AuthBootSplash />
  if (!isAuthenticated) {
    return <Navigate to='/login' replace state={{ from: location }} />
  }

  return children
}

const App = () => {
  const { ready = false } = useSelector((state) => state.auth)

  return (
    <BrowserRouter>
      {!ready
        ? <AuthBootSplash />
        : (
          <Routes>
            <Route path='/login' element={<LoginView />} />
            <Route
              path='/'
              element={
                <ProtectedRoute>
                  <DashboardView />
                </ProtectedRoute>
              }
            />
            <Route
              path='/vulnerabilities'
              element={
                <ProtectedRoute>
                  <DependencyTrackView mode='vulnerabilities' />
                </ProtectedRoute>
              }
            />
            <Route path='/dependency-track' element={<Navigate to='/vulnerabilities' replace />} />
            <Route
              path='/upgrades'
              element={
                <ProtectedRoute>
                  <UpgradesView />
                </ProtectedRoute>
              }
            />
            <Route
              path='/client-organization'
              element={
                <ProtectedRoute>
                  <ClientOrganizationView />
                </ProtectedRoute>
              }
            />
          </Routes>
          )}
    </BrowserRouter>
  )
}

export { App }
